import React from 'react';
import ImageTag from '../ImageTag/ImageTag';
import Footerlogo from '../Logo/Footer_Logo.svg';

const BtFooterLogo: React.FC = () => {
  return <ImageTag className="" src={Footerlogo} alt="Home" width="50" maxHeight="100" name={'Logo'} />;
};
export default BtFooterLogo;
